import React from 'react';

export default function SubmitBtn({ onClick, disabled, className }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label="submit"
      className={className}
    >
      <svg
        width="70"
        height="52"
        viewBox="0 0 70 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M65.5 26H4.5M65.5 26L44 4.5M65.5 26L44 47.5"
          stroke="white"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
